<template>
<button
 :class="{
    'level-item': true,
    button: true,
    'is-toggle': true,
    'is-on': isShowDueDates
  }"
  :title="isShowDueDates ? 'Show due dates' : 'Hide due dates'"
  @click="toggleDueDates"
>
  <clock-icon class="icon is-small" />
</button>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { ClockIcon } from 'vue-feather-icons'

export default {
  name: 'show-due-dates-button',
  components: {
    ClockIcon
  },

  props: {},

  computed: {
    ...mapGetters([
      'isShowDueDates'
    ])
  },

  methods: {
    ...mapActions([
      'showDueDates',
      'hideDueDates'
    ]),

    toggleDueDates () {
      if (this.isShowDueDates) {
        this.hideDueDates()
      } else {
        this.showDueDates()
      }
    }
  },

  mounted () {
    if (localStorage.getItem('show-due-dates') === 'false') {
      this.hideDueDates()
    } else {
      this.showDueDates()
    }
  },

  watch: {
    isShowDueDates () {
      localStorage.setItem(
        'show-due-dates',
        this.isShowDueDates,
        { expires: '1M' }
      )
    }
  }
}
</script>
